import React from "react";
import { Link } from "gatsby";
import { COMPANY_NAME } from "../config/site";
import useNavItems from "../hooks/useNavItems";

/**
 * Pie del sitio: la navegación pública y la línea legal.
 * No repite "Acceso clientes" ni "Cerrar sesión": eso vive en el encabezado.
 */
const Footer = () => {

	// Sin lista de precios: el pie muestra siempre la navegación pública
	const navItems = useNavItems();

	return (
		<footer className="border-t border-line bg-white py-8">
			<div className="shell flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center">
				<nav className="flex flex-wrap items-center gap-x-6 gap-y-2" aria-label="Navegación del pie">
					{
						navItems.map((item, index) => (
							<Link
								key={ index }
								to={ item.href }
								className="text-xs font-medium text-ink-soft transition-colors duration-200 hover:text-brand"
							>
								{ item.caption }
							</Link>
						))
					}
				</nav>

				<p className="m-0 text-[10px] uppercase tracking-[.08em] text-muted">
					© { new Date().getFullYear() } { COMPANY_NAME } · Uruguay
				</p>
			</div>
		</footer>
	);
};

export default Footer;
